import Cookies from 'js-cookie'
import { environmentService } from '@/services/Environment'
import type { FeatureFlag } from './types'

/** Set by the Vercel Toolbar to override flags in preview deployments. */
export const VERCEL_FLAG_OVERRIDES_COOKIE = 'vercel-flag-overrides'

/**
 * Flag overrides from the Vercel Toolbar cookie, applied over Optimizely's
 * values. Never on the production host: the cookie is plain, unsigned JSON
 * that any visitor can set, and production flags are controlled in
 * Optimizely. Previews, staging and local development keep the override.
 */
export function readVercelFlagOverrides(): Partial<
  Record<FeatureFlag, boolean>
> {
  if (environmentService.isProductionHost()) return {}

  const raw = Cookies.get(VERCEL_FLAG_OVERRIDES_COOKIE)
  if (!raw) return {}

  try {
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {}
    }
    // Flags here are on/off; anything else is ignored.
    return Object.fromEntries(
      Object.entries(parsed).filter(([, value]) => typeof value === 'boolean')
    ) as Partial<Record<FeatureFlag, boolean>>
  } catch (e: unknown) {
    if (e instanceof Error) {
      // eslint-disable-next-line no-console
      console.error(e.message)
    }
    return {}
  }
}
